if (!customElements.get('product-media')) {
  customElements.define(
    'product-media',
    class ProductMedia extends HTMLElement {
      constructor() {
        super()
        this.blazeSlider = null
      }

      connectedCallback() {
        this.initSlider()
      }

      disconnectedCallback() {
        if (this.blazeSlider) {
          this.blazeSlider.destroy()
          this.blazeSlider = null
        }
      }

      initSlider() {
        const sliderElement = this.querySelector('.blaze-slider')
        if (!sliderElement) return

        const slides = sliderElement.querySelectorAll('.blaze-slide')
        if (slides.length <= 1) {
          this.querySelector('.js-media-pagination')?.classList.add('hidden')
          return
        }

        if (typeof window.BlazeSlider === 'undefined') {
          const script = document.querySelector('script[src*="blaze-slider"]')
          if (script) {
            script.addEventListener('load', () => this.initSlider(), { once: true })
          }
          return
        }

        try {
          this.blazeSlider = new window.BlazeSlider(sliderElement, {
            all: {
              enableAutoplay: false,
              enablePagination: true,
              slidesToShow: 1,
              slidesToScroll: 1,
              transitionDuration: 300,
              transitionTimingFunction: 'ease-in-out',
              loop: true,
              draggable: true,
              slideGap: '0px',
            },
          })

          this.blazeSlider.onSlide((_stateIndex, firstSlideIndex) => {
            this.onSlideChange(firstSlideIndex)
          })

          this.setupThumbnails()
          this.setupNavigation()

          this.updateActiveThumbnail(0)
          this.syncNavigationState()
        } catch (error) {
          console.error('product-media: Error initializing BlazeSlider:', error)
        }
      }

      onSlideChange(stateIndex) {
        this.updateActiveThumbnail(stateIndex)
        this.scrollActiveThumbnailIntoView(stateIndex)
        this.syncNavigationState()
        this.handleDeferredMedia(stateIndex)
      }

      setupThumbnails() {
        this.thumbnails = this.querySelectorAll('.js-thumbnail-item')
        this.thumbnails.forEach((thumb) => {
          thumb.addEventListener('click', () => {
            const index = parseInt(thumb.dataset.index, 10)
            this.goToSlide(index)
          })
          thumb.addEventListener('keydown', (e) => {
            if (e.key !== 'Enter' && e.key !== ' ') return
            e.preventDefault()
            const index = parseInt(thumb.dataset.index, 10)
            this.goToSlide(index)
          })
        })
      }

      goToSlide(index) {
        const slider = this.blazeSlider
        if (!slider) return
        const stateIndex = slider.stateIndex
        const len = slider.states.length
        const loop = slider.config.loop
        const diff = Math.abs(index - stateIndex)
        const inverseDiff = len - diff
        const useOpposite = loop && diff > len / 2
        if (index === stateIndex) return
        if (index > stateIndex) {
          if (useOpposite) {
            slider.prev(inverseDiff)
          } else {
            slider.next(diff)
          }
        } else {
          if (useOpposite) {
            slider.next(inverseDiff)
          } else {
            slider.prev(diff)
          }
        }
      }

      updateActiveThumbnail(index) {
        this.thumbnails?.forEach((thumb) => {
          thumb.classList.toggle(
            'is-active',
            parseInt(thumb.dataset.index, 10) === index
          )
        })
      }

      handleDeferredMedia(activeIndex) {
        const slides = this.querySelectorAll('.blaze-slide')
        slides.forEach((slide) => {
          const slideIdx = parseInt(slide.getAttribute('data-slide-index'), 10)
          const isActive =
            !Number.isNaN(slideIdx) && slideIdx === activeIndex
          slide.querySelectorAll('deferred-media').forEach((el) => {
            if (typeof el.togglePlayer !== 'function') return
            if (isActive) {
              el.togglePlayer(false, false)
            } else {
              el.togglePlayer(true)
            }
          })
        })
      }

      setupNavigation() {
        const track = this.querySelector('.product-media-thumbnails__track')
        if (!track) return

        this.thumbTrack = track
        this.thumbScrollAmount = 55 // 45px thumb + 10px gap

        this.querySelectorAll('.js-slide-arrow').forEach((button) => {
          button.addEventListener('click', (event) => {
            const direction = event.currentTarget.getAttribute('data-direction')
            if (direction === 'prev') {
              track.scrollBy({ left: -this.thumbScrollAmount * 6, behavior: 'smooth' })
            } else {
              track.scrollBy({ left: this.thumbScrollAmount * 6, behavior: 'smooth' })
            }
            setTimeout(() => this.syncNavigationState(), 350)
          })
        })
      }

      scrollActiveThumbnailIntoView(index) {
        const thumb = this.thumbnails?.[index]
        if (thumb && this.thumbTrack) {
          thumb.scrollIntoView({ behavior: 'smooth', block: 'nearest', inline: 'nearest' })
        }
      }

      isAtStart() {
        if (!this.thumbTrack) return true
        return this.thumbTrack.scrollLeft <= 0
      }

      isAtEnd() {
        if (!this.thumbTrack) return true
        return this.thumbTrack.scrollLeft + this.thumbTrack.clientWidth >= this.thumbTrack.scrollWidth - 1
      }

      syncNavigationState() {
        const atStart = this.isAtStart()
        const atEnd = this.isAtEnd()
        this.querySelectorAll('.js-slide-arrow').forEach((button) => {
          const direction = button.getAttribute('data-direction')
          if (direction === 'prev' && atStart) {
            button.setAttribute('disabled', 'true')
          } else if (direction === 'next' && atEnd) {
            button.setAttribute('disabled', 'true')
          } else {
            button.removeAttribute('disabled')
          }
        })
      }
    }
  )
}
